import React, { useState } from 'react';
import { FaGlobe, FaFolderOpen } from 'react-icons/fa';
import './activity.css';

const Activity = () => {
  // State to handle dropdown visibility
  const [showDropdown, setShowDropdown] = useState(false);

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Array of activity data to be displayed
  const activities = [
    {
      date: 'Yesterday',
      items: [
        {
          icon: <FaFolderOpen />,
          text: 'Case #33369',
          url: '#',
          description: 'for',
          linkedText: 'ALL SAINTS DENTAL',
          linkedUrl: '#',
          caseText: 'Lyon Marianne',
          caseUrl: '#',
          extra: 'Case rescheduled to be sent on 8 Mar 2025'
        },
      ]
    },
    {
      date: '7 Mar 2025',
      items: [
        // List of items for this date
      ]
    }
  ];

  return (
    <div
      className="activity-container"
      style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        color: '#333'
      }}
    >
      {/* View All Dropdown */}
      <div
        className="activity-view-section"
        style={{
          position: 'relative',
          marginBottom: '20px'
        }}
      >
        {/* Label and Button */}
        <label
          className="activity-view-label"
          style={{
            fontWeight: 'bold',
            marginRight: '10px'
          }}
        >
          View
        </label>

        <button
          className="activity-view-button"
          onClick={toggleDropdown}
          style={{
            padding: '5px 10px',
            background: 'white',
            border: '1px solid #ccc',
            cursor: 'pointer',
            borderRadius: '5px'
          }}
        >
          <FaGlobe /> All ▼
        </button>

        {/* Dropdown menu */}
        {showDropdown && (
          <div
            className="activity-dropdown"
            style={{
              position: 'absolute',
              background: 'white',
              border: '1px solid #ccc',
              padding: '10px',
              boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
              zIndex: 10
            }}
          >
            <p>
              <FaGlobe /> All - All Updates
            </p>

            <p>
              <FaGlobe /> All - Accounts - Account Updates Only
            </p>

            <p>
              <FaGlobe /> All - Lab - Lab Updates Only
            </p>

            <p>
              <FaFolderOpen /> Cases Created - All Updates
            </p>
          </div>
        )}
      </div>

      {/* Mapping through activity data */}
      {activities.map((activity, index) => (
        <div
          key={index}
          style={{
            marginBottom: '20px'
          }}
        >
          {/* Activity Date */}
          <h3
            className="activity-date"
            style={{
              fontSize: '16px',
              marginBottom: '10px'
            }}
          >
            {activity.date}
          </h3>

          {/* Activity Items */}
          {activity.items.map((item, idx) => (
            <div
              key={idx}
              className="activity-item"
              style={{
                marginBottom: '10px'
              }}
            >
              {/* Activity Main Row */}
              <div
                className="activity-main-row"
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {/* Icon */}
                <span
                  className="activity-icon"
                  style={{
                    marginRight: '8px',
                    color: '#555'
                  }}
                >
                  {item.icon}
                </span>

                {/* Case */}
                <a
                  className="activity-case-link"
                  href={item.url}
                  style={{
                    color: '#0056b3',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    marginRight: '5px'
                  }}
                >
                  {item.text}
                </a>

                {/* Description */}
                <span
                  className="activity-description"
                  style={{
                    marginRight: '5px'
                  }}
                >
                  {item.description}
                </span>

                {/* Linked Text */}
                <a
                  className="activity-linked-text"
                  href={item.linkedUrl}
                  style={{
                    color: '#0056b3',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    marginRight: '5px'
                  }}
                >
                  {item.linkedText}
                </a>

                {/* Case Text */}
                {item.caseText && (
                  <a
                    className="activity-person-link"
                    href={item.caseUrl}
                    style={{
                      color: '#0056b3',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      marginLeft: '5px'
                    }}
                  >
                    {item.caseText}
                  </a>
                )}
              </div>

              {/* Extra Info */}
              {item.extra && (
                <div
                  className="activity-extra"
                  style={{
                    fontStyle: 'italic',
                    color: 'gray',
                    marginLeft: '25px'
                  }}
                >
                  {item.extra}
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Activity;